import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import useAuth from 'contexts/AuthContext';

// Blocks dashboard routes until the user is authenticated.
export default function AuthGuard({ children }) {
  const { user, initializing } = useAuth();
  const location = useLocation();

  if (initializing) return null;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

AuthGuard.propTypes = { children: PropTypes.node };
